import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28a29e9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-accent-50 px-4 py-2 flex items-center gap-2 text-accent-700 text-sm font-medium border-b border-accent-100"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1z" })
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Pinned ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "p-5" }
const _hoisted_6 = { class: "flex items-center justify-between mb-3" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center text-primary-600 font-medium text-sm"
}
const _hoisted_10 = { class: "font-medium text-primary-800 text-sm" }
const _hoisted_11 = { class: "text-xs text-primary-400" }
const _hoisted_12 = { class: "font-heading font-semibold text-primary-800 text-lg mb-2 line-clamp-2" }
const _hoisted_13 = {
  key: 0,
  class: "relative mb-3"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "absolute top-2 right-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_17 = { class: "text-primary-600 text-sm line-clamp-3 mb-4" }
const _hoisted_18 = { class: "flex items-center gap-3" }
const _hoisted_19 = {
  key: 1,
  class: "text-xs text-primary-400"
}
const _hoisted_20 = { class: "flex items-center gap-1 text-primary-500" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1))
const _hoisted_22 = { class: "text-sm" }

import { computed, PropType } from "vue";
import ReactionDisplay from "@/components/common/ReactionDisplay.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PropType<Post>,
    required: true,
  },
},
  emits: ["open"],
  setup(__props) {

const props = __props





const authorName = computed(() => {
  const first = props.post.author?.first_name || "";
  const last = props.post.author?.last_name || "";
  return `${first} ${last}`.trim() || "Neighbor";
});

const authorInitials = computed(() => {
  const first = props.post.author?.first_name?.[0] || "";
  const last = props.post.author?.last_name?.[0] || "";
  return (first + last).toUpperCase() || "?";
});

const commentCount = computed(() => {
  return props.post.comment_count ?? props.post.comments?.length ?? 0;
});

const firstImage = computed(() => {
  if (props.post.all_images && props.post.all_images.length > 0) {
    return props.post.all_images[0];
  }
  return props.post.image || null;
});

const imageCount = computed(() => {
  if (props.post.all_images && props.post.all_images.length > 0) {
    return props.post.all_images.length;
  }
  return props.post.image ? 1 : 0;
});

const categoryLabel = computed(() => {
  const labels: Record<string, string> = {
    looking_to_borrow: "Help Wanted",
    for_sale: "For Sale",
    free: "Free",
    service_to_offer: "Service",
    question: "Question",
    social: "Social",
    general: "General",
  };
  return labels[props.post.type] || "Post";
});

const categoryBadgeClass = computed(() => {
  const classes: Record<string, string> = {
    looking_to_borrow: "bg-orange-100 text-orange-700",
    for_sale: "bg-green-100 text-green-700",
    free: "bg-emerald-100 text-emerald-700",
    service_to_offer: "bg-blue-100 text-blue-700",
    question: "bg-purple-100 text-purple-700",
    social: "bg-pink-100 text-pink-700",
    general: "bg-primary-100 text-primary-700",
  };
  return classes[props.post.type] || classes.general;
});

const friendlyDate = computed(() => {
  const date = new Date(props.post.created_on);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  // Include year if post is from a different year
  const currentYear = now.getFullYear();
  const postYear = date.getFullYear();

  if (postYear !== currentYear) {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open', __props.post))),
    class: "bg-white rounded-xl border border-primary-100 shadow-soft hover:shadow-md transition-all cursor-pointer overflow-hidden"
  }, [
    (__props.post.is_pinned)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (__props.post.author?.profile)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.post.author.profile,
                alt: _unref(authorName),
                class: "w-10 h-10 rounded-full object-cover"
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(authorInitials)), 1)),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(authorName)), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(friendlyDate)), 1)
          ])
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["px-2.5 py-1 text-xs font-medium rounded-full", _unref(categoryBadgeClass)])
        }, _toDisplayString(_unref(categoryLabel)), 3)
      ]),
      _createElementVNode("h3", _hoisted_12, _toDisplayString(__props.post.title), 1),
      (_unref(firstImage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _unref(firstImage),
              alt: __props.post.title,
              class: "w-full h-48 object-cover rounded-lg"
            }, null, 8, _hoisted_14),
            (_unref(imageCount) > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_unref(imageCount)), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_17, _toDisplayString(__props.post.description), 1),
      _createElementVNode("div", {
        class: "flex items-center justify-between pt-3 border-t border-primary-100",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_18, [
          (__props.post.reactions && __props.post.reactions.length > 0)
            ? (_openBlock(), _createBlock(ReactionDisplay, {
                key: 0,
                reactions: __props.post.reactions,
                "max-display": 4,
                "show-label": false,
                "show-social-proof": true
              }, null, 8, ["reactions"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, " Be the first to react "))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(commentCount)), 1)
        ])
      ])
    ])
  ]))
}
}

})